import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { ODBackRow } from '../../../components/ODBackRow'
import { SiteUrls } from '../../../urls'
import { EndingShowsPropertyEditPage } from './EndingShowsPropertyEditPage'

interface IEndingShowsPropertyEditPageContainerProps {
  storyId: number
  endingId: number
  espId: number | null
  isFinal: boolean
}

export const EndingShowsPropertyEditPageContainer: React.FC<IEndingShowsPropertyEditPageContainerProps> = (
  props
) => {
  const { storyId, endingId, espId, isFinal } = props
  return (
    <>
      <Card>
        <CardBody>
          <ODBackRow
            link={SiteUrls.Admin.Story.EditEnding(storyId, endingId, isFinal)}
          />
          <hr />
          <EndingShowsPropertyEditPage
            storyId={storyId}
            endingId={endingId}
            espId={espId}
            isFinal={isFinal}
          />
        </CardBody>
      </Card>
    </>
  )
}
